import mensagens from '@/util/mensagens'
import cnpj from '@/util/cnpj'
import dayjs from 'dayjs'

const TOAST_DEFAULTS = {
  SOLID: true,
  TIMEOUT_MS: 5000
}

const mapearObjetos = (objetoDeOrigem, objetoDestino) => {
  return window.$.extend(objetoDestino, objetoDeOrigem)
}

const objetoVazio = (objeto) => {
  for (var atributo in objeto) {
    if (objeto.hasOwnProperty(atributo)) {
      return false
    }
  }
  return true
}

const validarCPF = (cpf) => {
  cpf = cpf.replace(/[^\d]+/g, '')
  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false
  let soma = 0
  for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i)
  let resto = 11 - (soma % 11)
  if (resto === 10 || resto === 11) resto = 0
  if (resto !== parseInt(cpf.charAt(9))) return false
  soma = 0
  for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i)
  resto = 11 - (soma % 11)
  if (resto === 10 || resto === 11) resto = 0
  return resto === parseInt(cpf.charAt(10))
}

const validarCNPJ = (valor) => cnpj.validar(valor)

export const valorVazio = (valor) => {
  return (valorEhNulo(valor) || (valor === '' || valor.length === 0))
}

export const valorEhNulo = (valor) => {
  return (valor === null || valor === undefined)
}

const obterDadosAlertaAposSalvarRegistro = (payload) => {
  let dadosAlerta = { exibir: false, mensagem: '' }

  let apresentarMensagemErrosValidacao = (payload.sucesso === false)

  if (apresentarMensagemErrosValidacao) {
    dadosAlerta.exibir = true
    if (!objetoVazio(payload.listaDeErros)) {
      dadosAlerta.mensagem = mensagens.errosFormularioCadastro
    } else if (payload.mensagem) {
      dadosAlerta.mensagem = payload.mensagem
    } else {
      dadosAlerta.mensagem = mensagens.falhaServidorSalvandoDados
    }
  }
  return dadosAlerta
}

const criarAlertaToastDeSucesso = (componente, titulo, mensagem) => {
  criarAlertaToast(componente, titulo, 'success', mensagem)
}

const criarAlertaToastDeErro = (componente, titulo, mensagem, solido = TOAST_DEFAULTS.SOLID, tempo = TOAST_DEFAULTS.TIMEOUT_MS) => {
  criarAlertaToast(componente, titulo, 'danger', mensagem, solido, tempo)
}

const criarAlertaToast = (componente, titulo, estilo, mensagem, solido = TOAST_DEFAULTS.SOLID, tempo = TOAST_DEFAULTS.TIMEOUT_MS) => {
  componente.$bvToast.toast(mensagem, {
    title: titulo,
    variant: estilo,
    solid: solido,
    autoHideDelay: tempo,
    bodyClass: 'toast-text-preline'
  })
}

const formatarData = (valor, formato = 'DD/MM/YYYY') => {
  if (valorEhNulo(valor) || valorVazio(valor)) {
    return null
  }
  const dataEhValida = validaData(valor)
  if (!dataEhValida) {
    return valor
  }
  const dataFormatada = dayjs(valor).format(formato)
  return dataFormatada
}

const validaData = (data) => {
  data = new Date(data)
  if (isNaN(data.getTime())) {
    return false
  }
  return true
}

const formatarDataBRParaISO = (data) => {
  const dataArray = data.split('/')
  const dia = dataArray[0]
  const mes = dataArray[1]
  const ano = dataArray[2]
  return ano + '-' + ('0' + mes).slice(-2) + '-' + ('0' + dia).slice(-2)
}

const adicionarMaisHorasAData = (valor, valorHora = 1) => {
  let dataCalculada = dayjs(valor).add(valorHora, 'hour').format('YYYY-MM-DD HH:mm')
  return dataCalculada
}

const ehValidoFormatoHora = (valor) => {
  let regex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/
  let horaEhValida = regex.test(valor)

  if (valorEhNulo(valor) || valorVazio(valor) || !horaEhValida || horaEhValida.toString() === 'Invalid Date') {
    return false
  }
  return true
}

const ehValidoFormatoData = (valor, formato = 'YYYY-MM-DD') => {
  let dataFormata = dayjs(valor).format(formato)
  let dataValida = dayjs(dataFormata).isValid()

  if (valorEhNulo(dataValida) || valorVazio(dataValida) || !dataValida) {
    return
  }
  return dataValida
}

const nomeDoMesDaData = (dataString) => {
  const data = new Date(dataString)

  const nomeDoMes = new Intl.DateTimeFormat('pt-BR', { month: 'long' }).format(data)
  return nomeDoMes
}

export const valorEhCelular = (valor) => {
  const valorNumerico = apenasNumeros(valor)
  if ((valorEhNulo(valorNumerico) || valorVazio(valorNumerico))) {
    return
  }
  const quantidadeDigitosCelular = valorNumerico.length >= 11
  return (quantidadeDigitosCelular)
}

export const valorEhTelefone = (valor) => {
  const valorNumerico = apenasNumeros(valor)
  if ((valorEhNulo(valorNumerico) || valorVazio(valorNumerico))) {
    return
  }
  const quantidadeDigitosTelefone = valorNumerico.length <= 10
  return (quantidadeDigitosTelefone)
}

export const valorEhCpf = (valor) => {
  const valorNumerico = apenasNumeros(valor)
  return (valorNumerico?.length <= 11)
}

export const valorEhCnpj = (valor) => {
  const valorNormalizado = cnpj.normalizarCnpj(valor)
  return (valorNormalizado?.length >= 14)
}

const apenasNumeros = (valor, ehMonetario = false) => {
  if ((valorEhNulo(valor) || valorVazio(valor))) {
    return null
  }

  if (ehMonetario) {
    valor = parseFloat(valor.replace(/[^0-9,]*/g, '').replace(',', '.')).toFixed(2)
    return valor
  }

  return valor.toString().replace(/[^0-9]/g, '')
}

const validarEmail = (valor) => {
  return /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(valor)
}

const subtrairDiasDeUmaData = (diasASubstrair, data = new Date()) => {
  const dataAtualMenosDiasInformados = data
  dataAtualMenosDiasInformados.setDate(dataAtualMenosDiasInformados.getDate() - diasASubstrair)
  return dataAtualMenosDiasInformados
}

const stringSoTemNumeros = (valor) => {
  return /^\d+$/.test(valor)
}

const abrirPopOver = (elemento, config) => {
  config['trigger'] = 'manual'
  elemento = window.$(elemento)
  let counter = null
  elemento.popover(config).on('click', function () {
    window.$(this).popover('hide')
  })
  elemento.popover(config).on('mouseenter', function () {
    let _this = this
    clearTimeout(counter)
    elemento.not(_this).popover('hide')
    counter = setTimeout(function () {
      if (window.$(_this).is(':hover')) {
        window.$(_this).popover('show')
      }
      window.$('.popover').on('mouseleave', function () {
        elemento.popover('hide')
      })
    }, 200)
  }).on('mouseleave', function () {
    let _this = this
    setTimeout(function () {
      if (!window.$('.popover:hover').length) {
        if (!window.$(_this).is(':hover')) {
          window.$(_this).popover('hide')
        }
      }
    }, 200)
  })
}

function definirCookie (name, value, minutos) {
  const date = new Date()
  date.setTime(date.getTime() + (minutos * 60 * 1000))
  const expires = 'expires=' + date.toUTCString()
  document.cookie = name + '=' + value + ';' + expires + ';path=/'
}

function obterCookie (nome) {
  const cookieNome = nome + '='
  const cookies = document.cookie.split(';')
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i]
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1)
    }
    if (cookie.indexOf(cookieNome) === 0) {
      return cookie.substring(cookieNome.length, cookie.length)
    }
  }
  return null
}
const formatarValorMonetarioComCifrao = (valor, configuracao = {}) => {
  if (valorVazio(valor) || isNaN(valor)) return 'R$ 0'
  const configuracaoDefault = {
    style: 'currency', currency: 'BRL', useGrouping: true
  }

  const configuracaoCombinada = {
    ...configuracaoDefault,
    ...configuracao
  }

  return new Intl.NumberFormat('pt-BR', configuracaoCombinada).format(valor)
}

const obterRegexCpf = /^(\d{3})(\d{3})(\d{3})(\d{2})$/
const obterRegexCnpj = /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})$/

const formatarCpfCnpj = (cpfCnpj) => {
  if (valorEhCnpj(cpfCnpj)) {
    const input = cnpj.normalizarCnpj(cpfCnpj)
    const match = input?.match(obterRegexCnpj)

    if (match) {
      const [, parte1, parte2, parte3, parte4, parte5] = match
      return `${parte1}.${parte2}.${parte3}/${parte4}-${parte5}`
    }

    return input
  }

  const input = apenasNumeros(cpfCnpj)
  if (valorEhCpf(input)) {
    const match = input.match(obterRegexCpf)

    if (match) {
      const [, parte1, parte2, parte3, parte4] = match
      return `${parte1}.${parte2}.${parte3}-${parte4}`
    }
  }
  return input
}

const atualizarUrlComTimestamp = (url) => {
  const dataAtual = new Date()
  const dataAtualFormatada = formatarData(dataAtual, 'YYYYMMDDHHmmss')
  return `${url}?data=${dataAtualFormatada}`
}

export default {
  mapearObjetos,
  objetoVazio,
  valorEhNulo,
  valorVazio,
  criarAlertaToast,
  criarAlertaToastDeSucesso,
  criarAlertaToastDeErro,
  formatarData,
  formatarDataBRParaISO,
  obterDadosAlertaAposSalvarRegistro,
  adicionarMaisHorasAData,
  ehValidoFormatoHora,
  ehValidoFormatoData,
  nomeDoMesDaData,
  apenasNumeros,
  validarEmail,
  subtrairDiasDeUmaData,
  abrirPopOver,
  stringSoTemNumeros,
  definirCookie,
  obterCookie,
  formatarValorMonetarioComCifrao,
  formatarCpfCnpj,
  validarCNPJ,
  validarCPF,
  obterRegexCpf,
  obterRegexCnpj,
  atualizarUrlComTimestamp
}
